import { getApiOrigin } from '@hungryroot/rest';

export class FacebookSignupHelper {
  _facebook_resp: fb.StatusResponse;
  expected_event: null | string;
  user_id: null | string;
  token: null | string | undefined;
  constructor(
    facebook_resp: fb.StatusResponse,
    expected_event: 'login' | 'signup'
  ) {
    this.user_id = null;
    this.token = null;
    this.expected_event = null;
    if (expected_event) {
      this.expected_event = ('' + expected_event).toLowerCase();
      // expected_event is ONLY used if our server returns a failure, to be able to provide some "dignity" to the
      // ga analytics
    }
    this._facebook_resp = facebook_resp;

    if (
      this._facebook_resp.status === 'connected' &&
      'authResponse' in this._facebook_resp
    ) {
      this.user_id = this._facebook_resp.authResponse.userID;
      this.token = this._facebook_resp.authResponse.accessToken;
    }
  }

  submit() {
    const deferred = $.Deferred();
    const promise = deferred.promise();
    let event_type;

    const errors: string[] = [];
    if (!this.user_id) {
      errors.push(
        'Bad Facebook user ID ' +
          this._facebook_resp.authResponse.userID +
          ' from rep with status ' +
          this._facebook_resp.status
      );
    }
    if (!this.token) {
      errors.push(
        'Bad Facebook token ' +
          this._facebook_resp.authResponse.accessToken +
          ' from rep with status ' +
          this._facebook_resp.status
      );
    }

    if (errors.length > 0) {
      deferred.reject({ errors: errors });
      return promise; // No need to look any further...
    }

    const options = {
      user_id: this.user_id,
      token: this.token,
    };

    const xhr = $.post(
      `${getApiOrigin()}/api/facebook_login`,
      options,
      (data) => {
        if (!data || !('created' in data)) {
          event_type = this.expected_event;
        } else {
          if (data['created'] === true) {
            event_type = 'signup';
          } else {
            event_type = 'login';
          }
        }

        if (typeof ga === 'function') {
          ga('send', 'event', event_type, 'success');
        }
        if (event_type === 'signup') {
          if (typeof dataLayer.push === 'function') {
            dataLayer.push({
              event: 'hr.signup.success',
              signup: {
                method: 'facebook',
              },
              customer: {
                id: data.customer.id,
                email: data.customer.email,
              },
            });
          }
        } else if (event_type === 'login') {
          if (typeof dataLayer.push === 'function') {
            dataLayer.push({
              event: 'hr.login.success',
              login: {
                method: 'facebook',
              },
              customer: {
                id: data.customer.id,
                email: data.customer.email,
              },
            });
          }
        }

        deferred.resolve({
          actual_event_type: event_type,
          server_data: data,
        });
      }
    );

    xhr.fail(
      (
        data: JQuery.jqXHR<{
          created?: boolean;
        }> & {
          created?: boolean;
        }
      ) => {
        if (!data || !('created' in data)) {
          // Most likely, we won't have 'data' here so try to use the backup (usually guessed through the image type)
          event_type = this.expected_event;
        } else {
          if (data['created'] === true) {
            event_type = 'signup';
          } else {
            event_type = 'login';
          }
        }
        if (typeof ga === 'function') {
          ga('send', 'event', event_type, 'failure');
        }
        errors.push('Bad server response');
        deferred.reject({ errors: errors });
      }
    );

    return promise;
  }
}
